import React from 'react';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { Hero } from './components/sections/Hero';
import { Isla } from './components/sections/Isla';
import { Saraswati } from './components/sections/Saraswati';
import { Elementos } from './components/sections/Elementos';
import { Transmutacion } from './components/sections/Transmutacion';
import { Presencia } from './components/sections/Presencia';
import { Testimonios } from './components/sections/Testimonios';
import { Llamado } from './components/sections/Llamado';
import { Detalles } from './components/sections/Detalles';
import { Facilitadoras } from './components/sections/Facilitadoras';
import { Inversion } from './components/sections/Inversion';
export function App() {
  return <div className="w-full min-h-full font-body" style={{
    backgroundColor: 'var(--cream)',
    color: 'var(--ink)'
  }} data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Isla data-id="element-4" />
        <Saraswati data-id="element-5" />
        <Elementos data-id="element-6" />
        <Transmutacion data-id="element-7" />
        <Presencia data-id="element-8" />
        <Testimonios data-id="element-9" />
        <Llamado data-id="element-10" />
        <Detalles data-id="element-11" />
        <Facilitadoras data-id="element-12" />
        <Inversion data-id="element-13" />
      </main>
      <Footer data-id="element-14" />
    </div>;
}